import { useEffect } from 'react';

import {
    useReactNativeProps as useEikaReactNativeProps,
    runningInRNWebView as nativeRunningInRNWebView,
    useNativeEventListener as nativeUseNativeEventListener,
} from '@eika-infrastruktur/mobilbank-lib';

import { mockedReactNativeProps } from '@/domain/digital-wallet/utils/apple-wallet-test-utils';
import { useMocks } from '@/domain/mock';

export const useNativeEventListener = !useMocks
    ? nativeUseNativeEventListener
    : (callback: Parameters<typeof nativeUseNativeEventListener>[0]) => {
          useEffect(() => {
              window.addEventListener('message', (event: MessageEvent) => {
                  if (event.data.type === 'mock') {
                      callback(event.data.mock);
                  }
              });
          }, [callback]);
      };

export const useReactNativeProps = !useMocks
    ? useEikaReactNativeProps
    : () => {
          return mockedReactNativeProps;
      };

export const runningInRNWebView = !useMocks ? nativeRunningInRNWebView : true;
